import React from 'react';
import './CasasVelasurBanner.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CasasVelasurBanner = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='banner-principal'>
        <Link to='/casas-velasur'>
          <div className='img-logo'>
            <img src='/assets/Logos/svg-iso-back-casas-velasur.svg' alt={t('casasVelasurBanner.altLogo')} />
          </div>
          <div className='contenedor-banner-letras'>
            <h1>{t('casasVelasurBanner.title')}</h1>
            <p>{t('casasVelasurBanner.subtitle')}</p>
          </div>
          <div className='banner-letras-separadas'>
            <p>{t('casasVelasurBanner.slogan')}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CasasVelasurBanner;
